<template>
  <div>
    <app-table-ex
      @isError="isError = $event"
      @isLoading="isLoading = $event"
      @rowClicked="showDetails((selectedRow = $event))"
      :url="url"
      :tableColumns="tableColumns"
      :isSimple="true"
    ></app-table-ex>
  </div>
</template>

<script>
export default {
  props: {
    filteredNames: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedRow: null,
      url: "/party/organization",
      tableColumns: [
        {
          data: "name",
          title: "Name",
          type: "string",
          render: null,
        },
      ],
      // filteredNames: [],
    };
  },
  mounted() {
    console.log(
      "Institution.vue mounted: Triggering institution list load via app-table-ex with URL:",
      this.url
    );
  },
  methods: {
    showDetails() {
      this.$emit("rowClicked", this.selectedRow);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/paywall/usage/sections/Institution.vue